/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateTime } from './DateTime';
export type MarkAsOutagePayload = {
    outageFeeApplies: MarkAsOutagePayload.outageFeeApplies;
    slotBookableAgain?: boolean;
    paidAt?: DateTime;
    paymentType?: MarkAsOutagePayload.paymentType;
};
export namespace MarkAsOutagePayload {
    export enum outageFeeApplies {
        YES = 'yes',
        NO = 'no',
        NOT_SELECTED = 'not-selected',
    }
    export enum paymentType {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
}

